export class LayoutNodeTree {
    data = '';
    layoutNodeType: 'ROW' | 'COLUMN' | 'WIDGET';
    widgetPlaceHolderId = '';
    widgetPlaceHolder = new WidgetPlaceHolder();
    widgetPlaceHolderConfig = new WidgetPlaceHolderConfig();
    layoutNodeArray: Array<LayoutNodeTree> = [];
    with: number;
    style = '';
    ionColProperties: IonColProperties
    ionRowProperties: ionRowProperties;

  setParams(params: any) {
    this.layoutNodeArray.forEach((node) => {
      node.setParams(params);
    });
    if (this.layoutNodeType == "WIDGET") {
      this.widgetPlaceHolder.setParams(params);
    }
  }
}

export class WidgetPlaceHolder {
    public param = {};
    setParams(params: any) {
        this.param =params;
    }
}
export class WidgetPlaceHolderConfig {
    param = {};
}


// https://ionicframework.com/docs/api/col#properties
export class IonColProperties {
    size;
    sizeSm;
}
export class ionRowProperties {
}
